/**
 * A layout locked in place: shown whatever layout was chosen, with the layout
 * switcher, its menu items and its shortcuts gone. For a plugin that runs a
 * screen full-time -- a station computer in Radio's station mode, or a window
 * a plugin opens for its own layout. Held in memory for this window only; the
 * plugin that locks it sets it again at each start (and is unlocked when it is
 * turned off: see core/plugins.ts).
 */

import { useSyncExternalStore } from "react";

let locked: { layout: string; owner: string } | null = null;
const listeners = new Set<() => void>();

export function lockLayout(layout: string | null, owner = "core") {
  if (layout === null && locked && locked.owner !== owner) return;
  locked = layout ? { layout, owner } : null;
  listeners.forEach((fn) => fn());
}

export const lockedLayout = (): string | null => locked?.layout ?? null;

export function useLockedLayout(): string | null {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    lockedLayout
  );
}
